module.exports = __webpack_public_path__ + "CreaturaMakes.webp?1bc46794d2904a1bc343c54d6c7944c2";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CreaturaMakes.webp
// module id = 66
// module chunks = 0